import React from 'react';
import { Tabs, Tab } from '@mui/material';
import CalculateIcon from '@mui/icons-material/Calculate';
import DashboardIcon from '@mui/icons-material/Dashboard';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';

/**
 * TabNavigation - switches between Calculator, Dashboard, and (admins only) Admin.
 *
 * @param {Object} props
 * @param {string} props.activeTab - 'calculator' | 'dashboard' | 'admin'
 * @param {Function} props.onTabChange - onTabChange(tabName)
 * @param {boolean} props.showAdmin - render the Admin tab (caller is an admin)
 */
function TabNavigation({ activeTab, onTabChange, showAdmin }) {
  return (
    <Tabs
      value={activeTab}
      onChange={(_, v) => onTabChange(v)}
      variant="fullWidth"
      sx={{ mb: 3, borderBottom: 1, borderColor: 'divider' }}
    >
      <Tab icon={<CalculateIcon />} iconPosition="start" label="Calculator" value="calculator" />
      <Tab icon={<DashboardIcon />} iconPosition="start" label="Dashboard" value="dashboard" />
      {showAdmin && <Tab icon={<AdminPanelSettingsIcon />} iconPosition="start" label="Admin" value="admin" />}
    </Tabs>
  );
}

export default TabNavigation;
